import React from 'react';

const tabs = [
  { key: 'overview', label: 'Overview' },
  { key: 'plan', label: 'Paket' },
  { key: 'features', label: 'Fitur' },
  { key: 'usage', label: 'Penggunaan' },
];

const TenantActionBar = ({ activeTab, setActiveTab, onRefresh }) => (
  <div className="flex flex-wrap items-center justify-between gap-2">
    <div className="flex items-center gap-2">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          onClick={() => setActiveTab(tab.key)}
          className={`rounded-md border px-3 py-1.5 text-xs ${activeTab === tab.key ? 'border-cyan-500/50 bg-cyan-500/10 text-cyan-100' : 'border-slate-700 bg-slate-950 text-slate-200'}`}
        >
          {tab.label}
        </button>
      ))}
    </div>
    <button
      type="button"
      className="rounded-md border border-slate-700 bg-slate-950 px-3 py-1.5 text-xs text-slate-200"
      onClick={onRefresh}
    >
      Refresh
    </button>
  </div>
);

export default TenantActionBar;
